module.exports = __webpack_public_path__ + "img/img8.1b745e48.png";